import { Box } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from 'assets/icons/v2';
import React, { ReactElement } from 'react';

type Props = {
  variant?: 'previous' | 'next';
  onClick?: () => void;
};

export const SliderButton = ({ variant = 'next', onClick }: Props): ReactElement => {
  const isNext = variant === 'next';
  return (
    <Box
      height="101%" // remove bg line bug in chrome
      mt="-1px"
      width="56px"
      bgColor="background.primary"
      opacity="0.95"
      display="grid"
      placeItems="center"
      cursor="pointer"
      onClick={onClick}
    >
      {isNext ? (
        <ChevronRightIcon boxSize="16px" color="text.secondary" />
      ) : (
        <ChevronLeftIcon boxSize="16px" color="text.secondary" />
      )}
    </Box>
  );
};
